import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nomatch',
  templateUrl: './nomatch.component.html',
  styleUrls: ['./nomatch.component.css']
})
export class NomatchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
